import React, { useState } from 'react'
import { emptyFunction, showToast } from '../../../utils'
import { makeDeleteCall } from '../../../effects/requests'
import { endPoints } from '../../../utils/endpoints'
import { ApiResponseType } from '../../../types'
import { DateUtils } from '../../../utils/dateUtils'
import SrciptDetails from './SrciptDetails'

const PerScript = ({ allData, onRefresh, onView }: any) => {

    const [scriptData, setScriptData] = useState<any>(null)
    const [openMenuId, setOpenMenuId] = useState<number | null>(null);

    const onDelete = (scriptId: any) => {
        const url = `${endPoints.LOCATION_SCRIPT}${scriptId}`
        makeDeleteCall(url).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                showToast(res?.status?.message, 'success');
                onRefresh?.()
            }
        }).catch(emptyFunction)
    }

    return (
        <div className="lv-table-wrap">
            <table className="lv-table">
                <thead>
                    <tr className="lv-table__head-row">
                        <th className="lv-table__th lv-table__th--thumb" />
                        <th className="lv-table__th">Script name</th>
                        <th className="lv-table__th">Number of Scenes</th>
                        <th className="lv-table__th">Created By</th>
                        <th className="lv-table__th">Date created</th>
                        <th className="lv-table__th">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {allData?.map((item: any, index: any) => {
                        return (
                            <tr
                                onClick={() => {
                                    if (openMenuId) {
                                        setOpenMenuId(null)
                                        return
                                    }
                                    onView?.(item)
                                }}
                                key={item?.id}
                                className="lv-table__row"
                            >
                                <td
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (openMenuId) {
                                            setOpenMenuId(null)
                                            return
                                        }
                                    }}
                                    className="lv-table__td lv-table__td--thumb"
                                >
                                    <img src={item?.cover_image_url || '/assets/images/yellow-6th.png'} alt={item?.name} className="lv-table__thumb" />
                                </td>
                                <td className="lv-table__td lv-table__td--name">{item?.name}</td>
                                <td className="lv-table__td">{item?.number_of_episodes || item?.number_of_scenes || '0'}</td>
                                <td className="lv-table__td">{item?.production_company_name || ''}</td>
                                <td className="lv-table__td">{item?.created_at ? `${DateUtils.formatDateTime(item?.created_at, 'DD MMMM YYYY')}` : ''}</td>
                                <td className="lv-table__td">
                                    <div className="lv-card__menu-wrap">
                                        <button
                                            className="lv-card__menu-btn"
                                            onClick={e => {
                                                e.stopPropagation();
                                                setOpenMenuId(openMenuId === item?.id ? null : item?.id);
                                            }}
                                        >
                                            <img src='/assets/images/three-dots-more.svg' alt='more' />
                                        </button>
                                        {openMenuId === item?.id && (
                                            <div className="lv-card__menu-dropdown">
                                                <button
                                                    type="button"
                                                    className="collection-card__dropdown-item"
                                                    onClick={() => setScriptData(item)}
                                                >
                                                    <img
                                                        src="/assets/images/view-meta.svg"
                                                        alt=""
                                                    />
                                                    <span>View Script</span>
                                                </button>
                                                <button
                                                    className="lv-card__menu-item"
                                                    onClick={() => onDelete?.(item?.id)}
                                                >
                                                    <img src='/assets/images/Delete-icon-red.svg' />
                                                    Delete
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>

            {scriptData?.id &&
                <SrciptDetails
                    onClose={() => setScriptData(null)}
                    srciptDetails={scriptData}
                    onRefresh={onRefresh}
                />
            }
        </div>
    )
}

export default PerScript